module.exports = __webpack_public_path__ + "img/teacherResource-4.0f424275.jpg";